import React from 'react';
import DataTable from './DataTableFigma';
import Loading from '../loading';
import useBackendData from '../../Helpers/useBackendData';

// A read-only list the backend sends whole, in one call: the loading indicator first, then the backend's refusal or
// the rows, each made into an item of type (a Domain item class), or emptyMessage when there are none. load is a
// function returning the call's promise; wrap it in useCallback, as useBackendData asks.
export default function LoadedDataTable({ load = null, failureMessage = '', type = null, emptyMessage = '' }) {
  const { data, error, isLoading } = useBackendData(load, failureMessage);

  if (isLoading) {
    return <Loading />;
  }
  if (error) {
    return <p>{error}</p>;
  }

  const items = (data ?? []).map((row) => new type(row));
  return (
    <DataTable
      itemList={items}
      type={type}
      selectable={false}
      thereIsNoSuchRowMessage={emptyMessage}
    />
  );
}
